import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="well">
        <div class="heading01 type01">
            <h1>{{ 'role.Manage rights and roles' | translate }}</h1>
            <a class="btn add" ui-sref="authorized.manage.permissions.roles.add()">{{ 'role.Add role' | translate }}</a>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length">
            <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'general.Role' | translate }}</a></th>
                    <th ng-class="vm.list.getSortClass('userCount')"><a ng-click="vm.list.sortBy('userCount')">{{ 'general.Users' | translate }}</a></th>
                </tr>
            </thead>
            <tbody>
                <tr ng-repeat="item in vm.list.items" ng-if="item.name">
                    <td>
                        <a ui-sref="authorized.manage.permissions.roles.detail.privileges({ id: item.id })">{{ item.name }}</a>
                    </td>
                    <td>{{ item.userCount }}</td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor (DATATABLES, ListFactory, RoleResource) {
        this.DATATABLES = DATATABLES;
        this.list = ListFactory.createWithPagination(RoleResource.query.bind(RoleResource));
        this.list.fetch();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/roles/list/index.js